import Vue from 'vue';
import Router from 'vue-router';
import Hello from '@/components/Hello';
import NameCard from '@/components/NameCard';
import ListUserRecommendations from '@/components/ListUserRecommendations'
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
    },
    {
      path: '/names/visibility/:visibility',
      name: 'Names',
      component: NameCard,
      props: true,
    },
    {
      path: '/mynames/',
      name: 'UserNames',
      component: ListUserRecommendations,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js